// ✅ src/scenes/notices/index.jsx

import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import Header from "../../components/Header";
import TicketTable from "../../components/TicketTable";
import TicketDetailModal from "../dashboard/TicketDetailModal";

// ✅ Centralized base URL with fallback
const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

const NoticesPage = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const fetchTickets = () => {
    fetch(`${BASE_URL}/api/tickets/notices`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => setTickets(data))
      .catch((err) => console.error("Failed to load notices:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchTickets();
    const interval = setInterval(fetchTickets, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleRowClick = (ticket) => setSelectedTicket(ticket);

  const handleUpdate = async ({ id, ticketFields, responseData }, closeOnSave = false) => {
    const body = { ...ticketFields, ...(responseData ? { newResponse: responseData } : {}) };

    const res = await fetch(`${BASE_URL}/api/tickets/${id}`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      console.error("Update failed");
      return null;
    }

    const updated = await res.json();
    fetchTickets();

    if (closeOnSave) setSelectedTicket(null);
    return updated;
  };

  return (
    <Box m="20px">
      <Header
        title="News Releases and Notices"
        subtitle="Tickets flagged for public or internal announcements"
      />

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TicketTable
          title="News Releases and Notices"
          tickets={tickets}
          onRowClick={handleRowClick}
          showAssignee={false} // omit the Assigned To column
        />
      )}

      <TicketDetailModal
        open={!!selectedTicket}
        ticket={selectedTicket}
        onClose={() => setSelectedTicket(null)}
        onUpdate={handleUpdate}
      />
    </Box>
  );
};

export default NoticesPage;